/* global bocAmchart4 */

/**
 * Decode the data if it's encoded for cases when it comes from the uploads or when webmart implements encoding
 *
 * @param {object} data Json data
 * @param {object} chart The current chart.
 * @return {object} decoded data
 */
bocAmchart4.decodeData = function (data, chart) {
    var modData = false;
    if (data.length === 1 && data[0].hasOwnProperty('data')) {
        modData = decodeURIComponent(escape(atob(data[0].data)));
    } else if (data.hasOwnProperty('data')) {
        modData = decodeURIComponent(escape(atob(data.data)));
    }

    if (modData) {
        data = JSON.parse(modData);


        if (chart.exporting.menu) {
            // Loop through all exporter menu options and remove the download all and download date range
            // options if they exist.
            // eslint-disable-next-line no-unused-vars
            for (const option of chart.exporting.menu.items[0].menu) {
                const menuLabel = chart.exporting.menu.items[0].menu[1].label;
                if (menuLabel == "Download all ..." || menuLabel == "Download date range ...") {
                    chart.exporting.menu.items[0].menu.splice(1, 1);
                }
            }
        }
    }

    return data;
};

/**
 * Set the the list of series and labels from the shortcode and add all the graphs to the chart
 * Also sets the valet_url based on the series list
 *
 * @param {array} fromShortcode Array of parameters taken from the shortcode
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {array|null} series Array of series to be added
 * @return {void}
 */
bocAmchart4.setValetDataLoader = function (fromShortcode, chartSettings, series) {
    var url, params;
    var hasMoreData = true;
    var count = 0;

    if (fromShortcode.hasOwnProperty('skipdataloading')) {
        return;
    }

    if (bocAmchart4.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            chartSettings.bocSettings.id,
            "Before setValetDataLoader:",
            bocAmchart4.debugClone(chartSettings),
            fromShortcode
        );
    }

    if ((typeof series === 'undefined' || (Array.isArray(series) && !series.length))
        && fromShortcode.hasOwnProperty('datasource')) {
        var homeUrl;
        if (window.hasOwnProperty("bocVars")) {
            homeUrl = window.bocVars.homeUrl;
        } else {
            homeUrl = window.CFCT.url;
        }
        url = homeUrl + fromShortcode['datasource'];
        chartSettings.bocSettings.series = 'group/CHART_DOWNLOAD';
    } else {
        if (typeof series === 'undefined') {
            series = [];

            while (hasMoreData) {
                if (fromShortcode.hasOwnProperty('series' + count)) {
                    var thisSeries = fromShortcode['series' + count];
                    series.push(thisSeries);
                } else if (!fromShortcode.hasOwnProperty('calculatedseries' + count)) {
                    hasMoreData = false;
                }
                count++;
            }
        }

        if (fromShortcode.hasOwnProperty('group')) {
            var group = fromShortcode['group'];
            chartSettings.bocSettings.series = 'group/' + group;
            url = window.valet_url + "observations/group/" + group + "/json";
        } else {
            chartSettings.bocSettings.series = series.join(',');
            url = window.valet_url + "observations/" + series.join(',') + "/json";
        }

        params = [
            'recent',
            'recent_weeks',
            'recent_months',
            'recent_years',
            'start_date',
            'end_date'
        ];
        var setParams = {};

        params.forEach(function (param) {
            if (fromShortcode.hasOwnProperty(param)) {
                setParams[param] = fromShortcode[param];
            }
        });

        // If there's no shortcode date related parameters defined, use post meta fields
        if (Object.keys(setParams).length === 0 && typeof window.startdate === 'string' && typeof window.enddate === 'string') {
            setParams['start_date'] = window.startdate;
            setParams['end_date'] = window.enddate;
        }

        // Check for per chart overrides of start date based on the crop parameters
        bocAmchart4.initChartVars(chartSettings);
        if (typeof bocAmchart4.vars[chartSettings.bocSettings.id]['startdateOverride'] === 'string') {
            setParams['start_date'] = bocAmchart4.vars[chartSettings.bocSettings.id]['startdateOverride'];
        }

        var setParamsStrings = [];
        if (Object.keys(setParams).length !== 0) {
            for (var property in setParams) {
                if (setParams.hasOwnProperty(property)) {
                    setParamsStrings.push(property + '=' + setParams[property]);
                }
            }
            url += '?' + setParamsStrings.join('&');
        }
    }

    chartSettings.dataSource.url = url;
    chartSettings.dataSource.events = chartSettings.dataSource.events || {};
    chartSettings.dataSource.events.parseended = bocAmchart4.whichPostProcessor(chartSettings);

    if (bocAmchart4.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            chartSettings.bocSettings.id,
            url,
            bocAmchart4.debugClone(chartSettings)
        );
    }
};

bocAmchart4.whichPostProcessor = function (chart) {
    let postProcessor = bocAmchart4.postProcessValet;

    if (chart.bocSettings.args.hasOwnProperty('xaxistype') &&
        (chart.bocSettings.args.xaxistype === 'text' || chart.bocSettings.args.xaxistype === 'number'
            || chart.bocSettings.args.xaxistype === 'time')) {
        postProcessor = bocAmchart4.postProcessValetCategories;
    }

    if (chart.bocSettings.hasOwnProperty('type')) {
        // prefer to keep it separate for clarity, as well, it will probably grow to more lines inside
        if (chart.bocSettings.type === 'pie') {
            postProcessor = bocAmchart4.postProcessValetCategories;
        }
        // prefer to keep it separate for clarity, as well, it will probably grow to more lines inside
        if (chart.bocSettings.type === 'map') {
            postProcessor = bocAmchart4.postProcessValetCategories;
        }
    }

    if (chart.bocSettings.args.hasOwnProperty('heatmap')) {
        postProcessor = bocAmchart4.postProcessValetTwoDimensions;
    }

    return postProcessor;
};
